import { useCallback, useEffect, useState } from "react";
import { API } from 'aws-amplify';
import { getAuthToken } from "../../../utils/AuthUtils";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import './styles.scss';

const CompanyTickersModal = ({ show, onClose, id }) => {
    const [companyId, setCompanyId] = useState(null);
    const [cik, setCIK] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [tickerData, setTickerData] = useState([]);
    const [successfullUpdate, setSuccessfullUpdate] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [hasOnePrimaryTicker, setHasOnePrimaryTicker] = useState(true);
    const [addingNewTicker, setAddingNewTicker] = useState(false);

    const handleClose = () => {
        setCompanyId(null);
        setCIK(null);
        setCompanyName(null);
        setLoading(false);
        setError(false);
        setErrorMessage("");
        setTickerData([]);
        setSuccessfullUpdate(false);
        setLoadingUpdate(false);
        setHasOnePrimaryTicker(true);
        setAddingNewTicker(false);
        onClose();
    }

    const handleAddNewTicker = () => {
        const tmpTickerData = [...tickerData];
        const index = tickerData.length;
        const newTicker = {
            companyId: companyId,
            cik: cik,
            companyName: companyName,
            ticker: "",
            exchange: "",
            isPrimary: false,
            updated: false,
            new: true,
            index: index
        }
        tmpTickerData.push(newTicker);
        setTickerData(tmpTickerData);
        setAddingNewTicker(true);
    }

    const handleRemoveNewTicker = () => {
        console.log(tickerData);
        let tmpTickerData = [...tickerData];
        tmpTickerData.pop();
        setTickerData(tmpTickerData);
        setAddingNewTicker(false);
    }

    const handleSetTickerData = (companyData) => {
        const tickers = [];
        let index = 0;
        for (const data of companyData) {
            if (data.isPrimaryTicker) {
                setCompanyName(data.companyName);
                setCompanyId(data.companyId);
                setCIK(data.cik);
            }
            const ticker = {
                companyId: data.companyId,
                cik: data.cik,
                companyName: data.companyName,
                ticker: data.ticker,
                exchange: data.exchange,
                isPrimary: data.isPrimaryTicker,
                updated: false,
                new: false,
                index: index
            }
            tickers.push(ticker);
            index += 1;
        }
        setTickerData(tickers);
    }

    const checkValieNewTicker = () => {
        for (const ticker of tickerData) {
            if (ticker.new) {
                if (!ticker.ticker || ticker.ticker.length === 0 || !ticker.exchange || ticker.exchange.length === 0) {
                    return false;
                }
            }
        }
        return true;
    }

    const UpdateData = async (e) => {
        setError(false);
        setErrorMessage("");
        setLoadingUpdate(true);
        checkHasOnePrimaryTicker();
        e.preventDefault();

        if (!hasOnePrimaryTicker) {
            setLoadingUpdate(false);
            setError(true);
            setErrorMessage("There must be one primary ticker");
            e.stopPropagation();
        } else if (!checkValieNewTicker()) {
            setLoadingUpdate(false);
            setError(true);
            setErrorMessage("New ticker and exchange and cannot be null");
            e.stopPropagation();
        } else {
            const authToken = await getAuthToken();
            API.post("AnnualCompensations", "/company-data/tickers",
                {
                    headers: {
                        'Token': authToken
                    },
                    body: tickerData
                }
            ).then(response => {
                setLoadingUpdate(false);
                setSuccessfullUpdate(true);
            }
            ).catch(error => {
                console.log(error)
                setError(true);
                setErrorMessage("Error updating tickers");
                setLoadingUpdate(false);
                setSuccessfullUpdate(false);
            })
        }
    }

    const handleChangeTicker = (e, index) => {
        const tmpTickers = [...tickerData];
        for (const ticker of tmpTickers) {
            if (ticker.index === index) {
                ticker.ticker = e.target.value;
                ticker.updated = true;
            }
        }
        setTickerData(tmpTickers);
    }

    const handleChangeExchange = (e, index) => {
        const tmpTickers = [...tickerData];
        for (const ticker of tmpTickers) {
            if (ticker.index === index) {
                ticker.exchange = e.target.value;
                ticker.updated = true;
            }
        }
        setTickerData(tmpTickers);
    }

    const handleChangePrimary = (e, index) => {
        const tmpTickers = [...tickerData];
        for (const ticker of tmpTickers) {
            if (ticker.index === index) {
                ticker.isPrimary = e.target.checked;
                ticker.updated = true;
            }
        }
        setTickerData(tmpTickers);
    }

    const checkHasOnePrimaryTicker = useCallback(() => {
        let count = 0;
        for (const ticker of tickerData) {
            if (ticker.isPrimary) {
                count += 1;
            }
        }
        if (count === 1) {
            setHasOnePrimaryTicker(true);
            return;
        } else {
            setHasOnePrimaryTicker(false);
            return;
        }
    }, [tickerData])

    useEffect(() => {
        checkHasOnePrimaryTicker();
    }, [tickerData, checkHasOnePrimaryTicker])

    useEffect(() => {
        if (id) {
            const retrieveCompanyDetails = async () => {
                setLoading(true);
                setError(false);
                setErrorMessage("");
                const authToken = await getAuthToken();
                const queryStringParameters = {
                    id: id
                }
                API.get("AnnualCompensations",
                    "/company-data/tickers", {
                    headers: {
                        'Content-Type': 'application/json',
                        Token: authToken,
                    },
                    queryStringParameters,
                }).then(response => {
                    handleSetTickerData(response)
                    setLoading(false);
                }).catch(error => {
                    console.log(error);
                    setLoading(false);
                    setError(true);
                    setErrorMessage("Error retrieving company details");
                })
            };
            retrieveCompanyDetails();
        }
    }, [id]);

    return (
        <div>
            <Modal show={show} onHide={handleClose} size='lg' centered>
                <div className="company-tickers-container">
                    <Modal.Header closeButton>
                        Company Tickers
                    </Modal.Header>
                    <Modal.Body>
                        {loading ? <Spinner as="span" animation="grow" size="sm" aria-hidden="true" /> : <>
                            <Form noValidate validated={hasOnePrimaryTicker} onSubmit={(e) => UpdateData(e)}>
                                {tickerData?.map((data, index) => {
                                    return (<Row>
                                        <Col md={4}>
                                            <Form.Group controlId="ticker">
                                                <Form.Label>Ticker</Form.Label>
                                                <Form.Control type="text" value={data.ticker} readOnly={!data.new} onChange={(e) => handleChangeTicker(e, index)} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group controlId="exchange">
                                                <Form.Label>Exchange</Form.Label>
                                                <Form.Control type="text" value={data.exchange} readOnly={!data.new} onChange={(e) => handleChangeExchange(e, index)} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1}>
                                            <Form.Group controlId="isPrimary" >
                                                <Form.Label>Primary</Form.Label>
                                                <Form.Check type="checkbox" checked={data.isPrimary} onChange={(e) => handleChangePrimary(e, index)} />
                                            </Form.Group>
                                        </Col>
                                        {addingNewTicker && data.new ? <Col md={1}>
                                            <div className="remove-ticker-button">
                                                <Button
                                                    title="Remove new Ticker"
                                                    variant="primary"
                                                    onClick={() => handleRemoveNewTicker()}
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </Button>
                                            </div>
                                        </Col> : null}
                                    </Row>);
                                })}
                                <Row>
                                    {addingNewTicker ? null :
                                        <div className="add-ticker-button">
                                            <Button
                                                title="Add new Ticker"
                                                varint="primary"
                                                onClick={() => handleAddNewTicker()}>
                                                <i className="fa fa-plus"></i>
                                            </Button>
                                        </div>
                                    }
                                </Row>
                                <Form.Control.Feedback type="invalid">
                                    Only one ticker can be primary
                                </Form.Control.Feedback>
                            </Form>

                        </>}
                        {error && <Alert dismissible variant="danger" show={error} onClose={() => setError(false)}>{errorMessage}</Alert>}
                        {successfullUpdate && <Alert dismissible variant="success" show={successfullUpdate} onClose={() => setSuccessfullUpdate(false)}>Ticker updated successful</Alert>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" type="submit" onClick={UpdateData}>{loadingUpdate ? <Spinner as="span" animation="grow" size="sm" aria-hidden="true" /> : "Update"}</Button>
                        <Button variant="secondary" onClick={handleClose}>Close</Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    )
}

export default CompanyTickersModal;